module.exports = require('./helpers/bundle-url').getBundleURL('iPMsF') + "logo.c51670a8.svg";